export const SearchResultsReferencePrefixes = {
  DocumentReference: 'CB_D',
  CommonReference: 'CB_C'
};